import { render, staticRenderFns } from "./chrome-tip.vue?vue&type=template&id=10e8fc4f&"
import script from "./chrome-tip.vue?vue&type=script&lang=js&"
export * from "./chrome-tip.vue?vue&type=script&lang=js&"
import style0 from "./chrome-tip.vue?vue&type=style&index=0&id=10e8fc4f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports